import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = "/landlord/tenants"

export default {
  get(id,pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource}/${id}/invoices?paginate=${pagination}&page=${pageNumber}`)
  },
}
